import debug from 'debug';
import PropTypes from 'prop-types';
import React from 'react';
import Search from '@mulesoft/ang-search-component/lib/search/ANGSearch';
import ANGFilters from '~/utils/ang/ANGFilters';
import styles from './ANGSearch.css';

const log = debug('exchange:ang-search:component');

class ANGSearch extends React.PureComponent {
  static propTypes = {
    angConfig: PropTypes.object,
    assetTypesConfiguration: PropTypes.object,
    onSearch: PropTypes.func,
    filters: PropTypes.instanceOf(ANGFilters).isRequired,
    isANGSidebarConsistencyEnabled: PropTypes.bool
  };

  static defaultProps = {
    angConfig: {},
    onSearch: () => {},
    isANGSidebarConsistencyEnabled: false
  };

  state = {
    angState: this.props.filters.getAsANGState()
  };

  static getDerivedStateFromProps(props, state) {
    const angState = props.filters.getAsANGState();

    if (state.prevANGState !== angState) {
      return {
        prevANGState: angState,
        angState
      };
    }

    return null;
  }

  handleChange = (angState) => {
    this.setState({
      angState
    });
  };

  handleSearch = (_, angState) => {
    const { assetTypesConfiguration, onSearch } = this.props;
    const filters = ANGFilters.buildFromANGState(
      angState,
      assetTypesConfiguration
    );

    log('transformed to', filters);

    onSearch(filters);
  };

  render() {
    const { angConfig: config, isANGSidebarConsistencyEnabled } = this.props;
    const { angState } = this.state;

    log('using config', config);
    log('using state', angState);

    return (
      <div className={styles.search}>
        <Search
          config={config}
          value={angState}
          executor={this.handleSearch}
          onValueChange={this.handleChange}
          placeholder={`Search ${
            isANGSidebarConsistencyEnabled ? '' : 'all '
          }assets`}
        />
      </div>
    );
  }
}

export default ANGSearch;
